import React  from "react";
import styled from "@emotion/styled";

const BurgerContainer = styled.div`
  display: flex;
  flex-direction: column;

  img {
    max-width: 400px;
  }

  img + img {
    margin-top: -20px;
  }
`

const IngredientsImage = styled.img`
`;

const ingredientsStyleLookup = {
  'american-cheese': {
    'margin-bottom': '-14px'
  },
  'tomato': {
    'margin-bottom': '10px'
  },
  'gherkin': {
    'margin-bottom': '10px'
  },
  horseradish: {
    'margin-bottom': '10px'
  },
  bacon: {
    'margin-bottom': '10px',
    'margin-top': '-14px'
  },
}

function getIngredientsStyle(slug) {
  if (ingredientsStyleLookup[slug]) {
    return ingredientsStyleLookup[slug]
  }
  return {};
}


const DoubleDownBurger = ({ construction, filling, spices, extras = [], sauces = [], salads = [], fillingImage }) => {
    return (
      <BurgerContainer>
        <IngredientsImage
          src={`/images/ingredients/${filling.frontmatter.slug}.png`}
          alt={filling.frontmatter.title}
          objectFit="contain"
        />
        {sauces.map((sauce) => {
          return (
            <IngredientsImage
              src={`/images/ingredients/${sauce.frontmatter.slug}.png`}
              alt={sauce.frontmatter.title}
              objectFit="contain"
              style={getIngredientsStyle(sauce.frontmatter.slug)}
            />
          );
        })}
        {salads.map((extra) => {
          return (
            <IngredientsImage
              src={`/images/ingredients/${extra.frontmatter.slug}.png`}
              alt={extra.frontmatter.title}
              objectFit="contain"
              style={getIngredientsStyle(extra.frontmatter.slug)}
            />
          );
        })}
        {extras.map((extra) => {
          return (
            <IngredientsImage
              src={`/images/ingredients/${extra.frontmatter.slug}.png`}
              alt={extra.frontmatter.title}
              objectFit="contain"
              style={getIngredientsStyle(extra.frontmatter.slug)}
            />
          );
        })}
        <IngredientsImage
          src={`/images/ingredients/${filling.frontmatter.slug}.png`}
          alt={filling.frontmatter.title}
          objectFit="contain"
        />
      </BurgerContainer>
    )
  }
  
  const DoubleDeckedBurger = ({ construction, filling, spices, extras = [], sauces = [], salads = [], fillingImage }) => {
  
    const contents = (
      <>
        {sauces.map((sauce) => {
          return (
            <IngredientsImage
              src={`/images/ingredients/${sauce.frontmatter.slug}.png`}
              alt={sauce.frontmatter.title}
              objectFit="contain"
              style={getIngredientsStyle(sauce.frontmatter.slug)}
            />
          );
        })}
        {salads.map((extra) => {
          return (
            <IngredientsImage
              src={`/images/ingredients/${extra.frontmatter.slug}.png`}
              alt={extra.frontmatter.title}
              objectFit="contain"
              style={getIngredientsStyle(extra.frontmatter.slug)}
            />
          );
        })}
        {extras.map((extra) => {
          return (
            <IngredientsImage
              src={`/images/ingredients/${extra.frontmatter.slug}.png`}
              alt={extra.frontmatter.title}
              objectFit="contain"
              style={getIngredientsStyle(extra.frontmatter.slug)}
            />
          );
        })}
        <IngredientsImage
          src={`/images/ingredients/${filling.frontmatter.slug}.png`}
          alt={filling.frontmatter.title}
          objectFit="contain"
        />
      </>
    )
  
    return (
      <BurgerContainer> 
        <IngredientsImage
          src={`/images/ingredients/standard-bun--top.png`}
          alt="Standard bun top"
          objectFit="contain"
          style={{ zIndex: 1 }}
        />
        {contents}
        <IngredientsImage
          src={`/images/ingredients/standard-bun--middle.png`}
          alt="Standard bun middle"
          objectFit="contain"
          style={{ zIndex: 1 }}
        />
        {contents}
        <IngredientsImage
          src={`/images/ingredients/standard-bun--bottom.png`}
          alt="Standard bun bottom"
          objectFit="contain"
        />
      </BurgerContainer>
    );
  }
  

export default function Burger  (props)  {
    const { construction, filling, spices, extras = [], sauces = [], salads = [], fillingImage } = props;
  
    const specialConstructionLookup = {
      'double-decked': DoubleDeckedBurger,
      'double-down': DoubleDownBurger
    }
  
    if (specialConstructionLookup[construction.frontmatter.slug]){
      const SpecialBurger = specialConstructionLookup[construction.frontmatter.slug];
      return <SpecialBurger {...props} />
    }
  
    return (
      <BurgerContainer> 
        <IngredientsImage
          src={`/images/ingredients/${construction.frontmatter.slug}--top.png`}
          alt={construction.frontmatter.title}
          objectFit="contain"
          style={{ zIndex: 1 }}
        />
        {sauces.map((sauce) => {
          return (
            <IngredientsImage
              src={`/images/ingredients/${sauce.frontmatter.slug}.png`}
              alt={sauce.frontmatter.title}
              objectFit="contain"
              style={getIngredientsStyle(sauce.frontmatter.slug)}
            />
          );
        })}
        {salads.map((extra) => {
          return (
            <IngredientsImage
              src={`/images/ingredients/${extra.frontmatter.slug}.png`}
              alt={extra.frontmatter.title}
              objectFit="contain"
              style={getIngredientsStyle(extra.frontmatter.slug)}
            />
          );
        })}
        {extras.map((extra) => {
          return (
            <IngredientsImage
              src={`/images/ingredients/${extra.frontmatter.slug}.png`}
              alt={extra.frontmatter.title}
              objectFit="contain"
              style={getIngredientsStyle(extra.frontmatter.slug)}
            />
          );
        })}
        <IngredientsImage
          src={`/images/ingredients/${filling.frontmatter.slug}.png`}
          alt={filling.frontmatter.title}
          objectFit="contain"
        />
        <IngredientsImage
          src={`/images/ingredients/${construction.frontmatter.slug}--bottom.png`}
          alt={construction.frontmatter.title}
          objectFit="contain"
        />
      </BurgerContainer>
  );
  }